import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import Icon from '../components/icon';
import SearchXIcon from '~icons/lucide/search-x';
import HomeIcon from '~icons/lucide/home';

interface Signature {
  Args: {};
}

const NotFoundTemplate: TOC<Signature> = <template>
  <div class="flex min-h-[50vh] flex-col items-center justify-center py-12">
    <div class="text-base-content/30 mb-4">
      <Icon @icon={{SearchXIcon}} class="inline-block h-20 w-20" />
    </div>

    <h1 class="mb-2 text-4xl font-bold">404</h1>
    <h2 class="mb-2 text-xl font-semibold">Page not found</h2>

    <p class="text-base-content/60 mb-6 max-w-md text-center">
      The page you're looking for doesn't exist or has been moved.
    </p>

    <LinkTo @route="index" class="btn btn-primary gap-2">
      <Icon @icon={{HomeIcon}} class="h-4 w-4" />
      Go home
    </LinkTo>
  </div>
</template>;

export default NotFoundTemplate;
